<template>
  <div id="main-box" class="page flex flex-col mh100">
    <el-form>
      <el-form-item>
        <toolbar id="btn-box" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item>
    </el-form>
    <div class="flex-1 overA">
      <el-table :data="sysResellerList" highlight-current-row v-loading="tableLoading"
        @current-change="selectCurrentRow" style="width: 100%" border>
        <el-table-column prop="id" label="id" min-width="100" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="displayName" label="显示名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="code" label="唯一编码" min-width="100" align="center"></el-table-column>
        <el-table-column prop="openApiAppId" label="分配的AppId" min-width="100" align="center"></el-table-column>
        <el-table-column prop="openApiAppSecret" label="分配的AppSecret" min-width="100" align="center">
        </el-table-column>
        <el-table-column prop="openApiIsConnected" label="开放接口是否接通" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.openApiIsConnected ? 'success' : 'danger'" disable-transitions>{{
                scope.row.openApiIsConnected ? "已接通" : "未接通"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remoteAppId" label="外部系统分配的AppId" min-width="100" align="center"></el-table-column>
        <el-table-column prop="remoteAppSecret" label="外部系统分配的AppSecret" min-width="100" align="center">
        </el-table-column>
        <el-table-column prop="remoteRequestUrl" label="外部系统调用地址" min-width="100" align="center"></el-table-column>
        <el-table-column prop="remoteCallbackUrl" label="外部系统消息回调地址" min-width="100" align="center"></el-table-column>
        <el-table-column prop="remoteIsConnected" label="请求对接是否接通" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.remoteIsConnected ? 'success' : 'danger'" disable-transitions>{{
                scope.row.remoteIsConnected ? "已接通" : "未接通"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isActive" label="是否启用" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isActive ? "正常"
                : "禁用"
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" :total="total"
      :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="sysResellerFormVisible" v-if="sysResellerFormVisible"
      v-model="sysResellerFormVisible" :close-on-click-modal="false">
      <el-form :model="sysResellerForm" label-width="200px" :rules="sysResellerFormRules" ref="sysResellerForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="sysResellerForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="显示名称" prop="displayName">
          <el-input v-model="sysResellerForm.displayName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="唯一编码" prop="code">
          <el-input v-model="sysResellerForm.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="分配的AppId" prop="openApiAppId">
          <el-input v-model="sysResellerForm.openApiAppId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="分配的AppSecret" prop="openApiAppSecret">
          <el-input v-model="sysResellerForm.openApiAppSecret" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开放接口是否接通" prop="openApiIsConnected">
          <el-select v-model="sysResellerForm.openApiIsConnected">
            <el-option label="已接通" :value="true"></el-option>
            <el-option label="未接通" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外部系统分配的AppId" prop="remoteAppId">
          <el-input v-model="sysResellerForm.remoteAppId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="外部系统分配的AppSecret" prop="remoteAppSecret">
          <el-input v-model="sysResellerForm.remoteAppSecret" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="外部系统调用地址" prop="remoteRequestUrl">
          <el-input v-model="sysResellerForm.remoteRequestUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="外部系统消息回调地址" prop="remoteCallbackUrl">
          <el-input v-model="sysResellerForm.remoteCallbackUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="请求对接是否接通" prop="remoteIsConnected">
          <el-select v-model="sysResellerForm.remoteIsConnected">
            <el-option label="已接通" :value="true"></el-option>
            <el-option label="未接通" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-select v-model="sysResellerForm.isActive">
            <el-option label="正常" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自定义扩展">
          <div id="extend-content"></div>
          <div class="option">
            <div class="btn" @click="addExtension">+添加扩展</div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="sysResellerFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitSysReseller" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  CreateSysReseller,
  UpdateSysReseller,
  GetAllSysReseller,
  GetSysResellerDetail
} from "../../../api/api";
import toolbar from "../../../components/Toolbar";
import { getButtonList } from "../../../promissionRouter";
export default {
  components: { toolbar },
  data() {
    return {
      buttonList_toolBar: [],

      sysResellerList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        pageIndex: 1,
        pageSize: 10
      },

      sysResellerFormVisible: false,
      isEdit: false,
      sysResellerForm: {
        name: null,
        displayName: null,
        code: null,
        openApiAppId: null,
        openApiAppSecret: null,
        openApiIsConnected: false,
        remoteAppId: null,
        remoteAppSecret: null,
        remoteRequestUrl: null,
        remoteCallbackUrl: null,
        remoteIsConnected: false,
        isActive: true
      },
      sysResellerFormRules: {
        // name: [
        //   { required: true, message: '请输入name', trigger: 'blur' },
        //   { message: '请输入name', trigger: ['blur', 'change'] }
        // ]
      },
      submitLoading: false
    };
  },
  mounted() {
    window.deleteExtendBox = this.deleteExtendBox;
    this.getSysResellerList();
    this.renderButton();
  },
  methods: {
    emptyErrStyle(elements) {
      for (var i = 0, len = elements.length; i < len; i++) {
        let input = elements[i];
        let extendBox = input.closest('.extend-box');
        input.classList.remove("input-err");
        extendBox.classList.remove("box-err");
      }
    },
    addExtension() {
      let html = `
        <div class="extend-box">
          key：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          &nbsp;&nbsp;value：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          <div class="delete-icon" onclick="deleteExtendBox(this)">
            <img />
          </div>
        </div>
      `;
      let rebateContent = document.getElementById('extend-content');
      rebateContent.insertAdjacentHTML('beforeend', html);
    },
    deleteExtendBox(e) {
      let parent = e.closest('.extend-box');
      parent.parentNode.removeChild(parent);
    },
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getSysResellerList() {
      this.tableLoading = true;
      let params = {
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllSysReseller(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.sysResellerList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getSysResellerList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getSysResellerList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getSysResellerList();
    },
    empty() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getSysResellerList();
    },
    addSysReseller() {
      this.sysResellerFormVisible = true;
      this.isEdit = false;
      this.sysResellerForm = {
        name: null,
        displayName: null,
        code: null,
        openApiAppId: null,
        openApiAppSecret: null,
        openApiIsConnected: false,
        remoteAppId: null,
        remoteAppSecret: null,
        remoteRequestUrl: null,
        remoteCallbackUrl: null,
        remoteIsConnected: false,
        isActive: true
      }
    },
    editSysReseller() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetSysResellerDetail(params).then((res) => {
        if (res.data.success) {
          that.sysResellerForm = res.data.result;
          that.isEdit = true;
          that.sysResellerFormVisible = true;
          this.$nextTick(() => {
            let extendData = JSON.parse(this.sysResellerForm.extensionJson);
            if (extendData.length > 0) {
              let html = "";
              for (var i = 0; i < extendData.length; i++) {
                var el = extendData[i];
                let key = el.key;
                let value = el.value;
                html += "<div class=\"extend-box\">key：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value=" + key + ">&nbsp;&nbsp;value：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value=" + value + "><div class=\"delete-icon\" onclick=\"deleteExtendBox(this)\"><img /></div></div>";
              }
              let rebateContent = document.getElementById('extend-content');
              rebateContent.insertAdjacentHTML('beforeend', html);
            }
          });
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitSysReseller() {
      let that = this;
      that.$refs.sysResellerForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {

            // 处理扩展字段
            var elements = document.querySelectorAll('#extend-content input');
            this.emptyErrStyle(elements);
            for (var i = 0, len = elements.length; i < len; i++) {
              let input = elements[i];
              if (input.value == "") {
                let extendBox = input.closest('.extend-box');
                this.$message.error('不能为空');
                input.classList.add("input-err");
                extendBox.classList.add("box-err");
                return;
              }
            }
            this.extendList = [];
            for (var i = 0, len = elements.length; i < len; i++) {
              this.extendList.push({
                key: elements[i].value,
                value: elements[i + 1].value
              });
              i += 1;
            }
            that.sysResellerForm.extensionJson = JSON.stringify(this.extendList);

            that.submitLoading = true;
            if (!that.isEdit) {
              CreateSysReseller(that.sysResellerForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.sysResellerFormVisible = false;
                  that.getSysResellerList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateSysReseller(that.sysResellerForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.sysResellerFormVisible = false;
                  that.getSysResellerList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => { });
        }
      });
    }
  }
};
</script>
<style scoped>
#main-box {
  /* width: 100%;
  height: 100%;
  padding-top: 40px; */
}

#btn-box {
  /* position: fixed;
  height: 60px;
  top: 94px;
  padding-left: 20px;
  padding-top: 16px; */
}

#content-box {
  /* padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto; */
}

#main-box /deep/ .el-pagination {
  /* padding: 10px 5px; */
}

#main-box /deep/ #extend-content {
  /* padding: 20px 0 0 0;
  max-height: 200px;
  overflow-y: auto; */
}

#main-box /deep/ #extend-content::-webkit-scrollbar {
  width: 8px;
}

#main-box /deep/ #extend-content::-webkit-scrollbar-track {
  background-color: #F1F1F1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

#main-box /deep/ #extend-content::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

#main-box /deep/ .extend-box {
  width: 360px;
  height: 34px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  border-radius: 6px;
  padding: 3px 10px;
}

#main-box /deep/ .extend-box.box-err {
  background-color: #FEF0F0;
}

#main-box /deep/ .extend-box input {
  width: 70px !important;
  height: 100% !important;
  line-height: 36px;
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

#main-box /deep/ .extend-box input.input-err {
  border: #F56C6C solid 1px;
}

#main-box /deep/ .delete-icon {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 15px;
}

#main-box /deep/ .delete-icon img {
  width: 20px;
  height: 20px;
  content: url(../../../assets/close.png);
  cursor: pointer;
}

#main-box /deep/ .delete-icon img:hover {
  transform: scale(1.2);
}

#main-box /deep/ .option {
  width: 330px;
  display: flex;
  justify-content: space-between;
}

#main-box /deep/ .option .btn {
  color: #409EFF;
  cursor: pointer;
}

#main-box /deep/ .el-dialog__body {
  padding: 10px 20px 0 20px;
}

#main-box /deep/ .el-dialog__body .el-form-item {
  margin-bottom: 15px;
}

#main-box /deep/ .el-dialog__footer {
  padding: 0 20px 20px 20px;
}

#main-box /deep/ .dialog-footer {
  padding: 0 20px 0 20px;
}
</style>

